
                                            //BaseFeatureController
/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var BaseFeatureController={};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        BaseFeatureController = Marionette.Controller.extend({
            initialize: function (options) {


            },
            getAnchorView:function(){

            },
            getEditView:function(){

            }


        });
    });
    return BaseFeatureController;

});